
import { CandidateInvitationAPIFormType, CandidateInvitationResponseType } from '../../types/CandidateInvitation';
import { axiosInstance } from './index';

export const candidateInvitationService = {
    async candidateInvitationAndCount(param: CandidateInvitationAPIFormType) {
        const { data } = await axiosInstance.post(`Candidate/CandidateJoinByInvitation`, param);
        return data as CandidateInvitationResponseType;
    },
};